import thankYouJson from '../../../assets/translations/thank-you.json'

export const thankYouContent: any = thankYouJson
// // sonar-ignore
// export const thankYouContent: any = {
//   EN: {
//     'appDescription': 'Download our app',
//     'appSubHeading': 'To help you every step of the way, download the IDP Live app.',
//     'courseInformation': 'View latest course and uni info',
//     'recommendations': 'Receive personalised recommendations',
//     'advice': 'Get advice from students worldwide',
//     'trackApplication': 'Track your application',
//     'promoDescription': 'Scan the QR code or search for IDP Live app in the Google Play or Apple App Store',
//     'thanks': 'Thank You!',
//     'thanksExisting': 'Welcome back!',
//     'thanksMessage': 'Please take a seat and a counsellor will be right with you.',
//     'done': 'Done'
//   },
//   KH_KHM: {
//     'appDescription': 'Download our app',
//     'appSubHeading': 'ដើម្បីជាជំនួយសំរាប់អ្នកគ្រប់ជំហាននោះ, សូមដោនឡុតកម្មវិធី IDP Study Abroad សំរាប់ទូរស័ព្ទ',
//     'courseInformation': 'ពិនិត្យឡើងវិញនូវមុខវិជ្ជាសិក្សា ចុងក្រោយបង្អស់ ព្រមទាំងពត៌មានសាកលវិទ្យាល័យ',
//     'recommendations': 'ទទួលបានការផ្តល់ដំបូន្នានផ្ទាល់ខ្លូន',
//     'advice': 'ទទួលបានយោបល់ពីសិស្សានុសិស្សជុំវិញ ពិភពលោក',
//     'trackApplication': 'ធ្វើការតាមដានពាក្យសុំចូលសិក្សារបស់អ្នក',
//     'promoDescription': 'សូមេធ្វើការស្កេន QR code  ឫធ្វើការស្វែងរកកម្មវិធី IDP Study Abroad នៅក្នុង Google Play ឫ នៅក្នុង Apple App Store',
//     'thanksExisting': 'រីករាយដែលបានជួបអ្នក',
//     'thanksMessage': 'សូមអញ្ជើញអង្គុយ, អ្នកប្រឹក្សាយោបល់នឹងមកជួបអ្នកឥលូវ   នេះ',
//     'done': 'រួចរាល់',
//     'thanks': 'អរគុណ'
//   },
//   // Vietnam language support
//   VN_VIE: {
//     'appDescription': 'Download our app',
//     'appSubHeading': 'To help you every step of the way, download the IDP Study Abroad app.',
//     'courseInformation': 'View latest course and uni info',
//     'recommendations': 'Receive personalised recommendations',
//     'advice': 'Get advice from students worldwide',
//     'trackApplication': 'Track your application',
//     'promoDescription': 'Scan the QR code or search for IDP Study Abroad app in the Google Play or Apple App Store',
//     'thanksExisting': 'Great to see you!',
//     'thanksMessage': 'Please take a seat and a counsellor will be right with you.',
//     'done': 'Done',
//     'thanks': 'Cảm ơn bạn'
//   },
//   // Indonesia
//   ID_IND: {
//     'appDescription': 'Unduh aplikasi kami',
//     'appSubHeading': 'Untuk membantu Anda di setiap langkah, unduh aplikasi IDP Study Abroad',
//     'courseInformation': 'Lihat jurusan terbaru dan info universitas',
//     'recommendations': 'Terima rekomendasi sesuai kebutuhan personal Anda',
//     'advice': 'Dapatkan saran dari para siswa dari seluruh dunia',
//     'trackApplication': 'Lacak aplikasi Anda',
//     'promoDescription': 'Pindai QR Code atau cari aplikasi IDP Study Abroad di Google Play atau Apple App Store',
//     'thanksExisting': 'Selamat datang kembali!',
//     'thanksMessage': 'Silakan duduk dan konselor akan segera bersama Anda',
//     'done': 'Selesai',
//     'thanks': 'Terima Kasih'
//   },
//   // Korea
//   KR_KOR: {
//     'appDescription': '우리 어플리케이션을 다운로드 하세요.',
//     'appSubHeading': '모든 단계를 도와드리기 위해, IDP 라이브 앱을 다운로드 하세요.',
//     'courseInformation': '해외 명문대 최신 정보 안내',
//     'recommendations': '유학과정 추천 제공',
//     'advice': '재학생, 졸업생 후기',
//     'trackApplication': '지원서 현황',
//     'promoDescription': 'QR코드를 스캔하거나 구글플레이 혹은 애플 앱스토어에서 IDP Study Abroad 앱을 검색하세요!',
//     'thanksExisting': '다시 IDP 한국지사를 찾아주셔서 감사드립니다!',
//     'thanksMessage': '잠시만 기다려 주시면 담당 카운셀러님이 상담해 드릴 예정입니다.',
//     'done': '완료',
//     'thanks': '감사합니다.'
//   },
//   // Thailand
//   TH_THA: {
//     'appDescription': 'ดาวน์โหลดแอป',
//     'appSubHeading': 'เพื่อการช่วยเหลือทุกขั้นตอน ดาวน์โหลดแอป IDP Live',
//     'courseInformation': 'ดูข้อมูล ค้นหารายละเอียดคอร์สเรียน',
//     'recommendations': 'ขอรับคำแนะนำเกี่ยวกับการเรียนต่อต่างประเทศ',
//     'advice': 'เทคนิคและคำแนะนำจากนักเรียนประสบกาณ์ตรง',
//     'trackApplication': 'ติดตามสถานะการสมัครของคุณ',
//     'promoDescription': 'สแกน QR Code หรือ ค้นหา IDP Study Abroad app บน Google Play หรือ Apple App Store',
//     'thanksExisting': 'ยินดีต้อนรับกลับมา!',
//     'thanksMessage': 'กรุณารอสักครู่ เจ้าหน้าที่แนะแนวของเราพร้อมให้คำปรึกษาคุณในไม่ช้า',
//     'done': 'เสร็จสิ้น',
//     'thanks': 'ขอบคุณสำหรับการกรอกแบบฟอร์ม'
//   },
//   // Turkey
//   TR_TUR: {
//     'appDescription': 'Download our app',
//     'appSubHeading': 'Size her adımınızda yardımcı olabilmemiz için IDP Yurt Dışı Eğitim uygulamamızı indirin.',
//     'courseInformation': 'Planladığınız eğitimle ilgili son güncellemeleri öğrenin',
//     'recommendations': 'Kişiselleştirilmiş öneriler alın',
//     'advice': 'Gitmek istediğiniz ülkelerde okuyan öğrencilerden tavsiye alın',
//     'trackApplication': 'Başvurularınızı takip edin',
//     'promoDescription': "QR kodunu tarayın veya Google Play ya da Apple App Store'da IDP Study Abroad uygulamasını arayın",
//     'thanksExisting': 'Sizi gördüğümüze çok sevindik!',
//     'thanksMessage': 'Lütfen arkanıza yaslanın, birazdan size bir danışmanımız yardımcı olacak.',
//     'done': 'Tamamla',
//     'thanks': 'Teşekkürler'
//   },
//   // Arabia
//   SA_ARA: {
//     'appDescription': 'Download our app',
//     'appSubHeading': 'لمساعدتك في كل خطوة على الطريق ، قم بتنزيل تطبيق IDP Study Abroad.',
//     'courseInformation': 'احصل على توصيات ونصائح خاصة لك ',
//     'recommendations': 'احصل على مشورة من الطلاب حول العالم ',
//     'advice': 'تتبع طلبك للتقديم بالجامعة ',
//     'trackApplication': '',
//     'promoDescription': 'امسح الرمز بكاميرا هاتفك أو ابحث عن تطبيق IDP Study Abroad   في متجر Google Play  أو Apple App Store',
//     'thanksExisting': 'يسعدنا رؤيتك!',
//     'thanksMessage': 'برجاء الانتظار سيكون أحد مستشارينا معك حالاً ',
//     'done': 'إنهاء',
//     'thanks': 'شكراً'
//   },
//   // Taiwan
//   TW_CHI: {
//     'appDescription': '下載我們的APP',
//     'appSubHeading': '為了幫助您走好每一步，請下載IDP Live app',
//     'courseInformation': '查看最新課程與學校資訊',
//     'recommendations': '收到客製化專屬推薦',
//     'advice': '得到全球各地學生的建議',
//     'trackApplication': '追蹤你的申請',
//     'promoDescription': '請掃描QR Code，或前往 Google Play 或 Apple App Store 搜尋 IDP Study Abroad 。',
//     'thanksExisting': '歡迎回來！',
//     'thanksMessage': '請稍作休息，留學顧問將盡快與你接洽。',
//     'done': '完成',
//     'thanks': '謝謝'
//   },
//   // Hong Kong
//   HK_ZK: {
//     'appDescription': '下载我们的APP',
//     'appSubHeading': '为了帮助您走好每一步，请下载IDP Live app',
//     'courseInformation': '查看最新课程和大学信息',
//     'recommendations': '收到个人化推荐',
//     'advice': '从世界各地的学生获得建议',
//     'trackApplication': '追踪你的申请',
//     'promoDescription': '扫描QR码或在Google Play / Apple App Store中搜索IDP Study Abroad应用程式',
//     'thanksExisting': '欢迎回来！',
//     'thanksMessage': '请先到学生等候位置坐下，升学顾问即将与你会面。',
//     'done': '完成',
//     'thanks': '谢谢'
//   },
//   // Hong Kong
//   HK_CHI: {
//     'appDescription': '下載我們的APP',
//     'appSubHeading': '為了幫助您走好每一步，請下載IDP Live app',
//     'courseInformation': '查看最新課程和大學訊息',
//     'recommendations': '收到個人化推薦',
//     'advice': '從世界各地的學生獲得建議',
//     'trackApplication': '追蹤你的申請',
//     'promoDescription': '掃描QR碼或在Google Play / Apple App Store中搜索IDP Study Abroad應用程式',
//     'thanksExisting': '歡迎回來！',
//     'thanksMessage': '請先到學生等候位置坐下，升學顧問即將與你會面。',
//     'done': '完成',
//     'thanks': '謝謝'
//   },
//   // China
//   CN_ZK: {
//     'appDescription': '下载我们的APP',
//     'appSubHeading': '为了帮助您走好每一步，请下载IDP Live app',
//     'courseInformation': '查看最新课程和大学信息',
//     'recommendations': '收到个人化推荐',
//     'advice': '从世界各地的学生获得建议',
//     'trackApplication': '追踪你的申请',
//     'promoDescription': '扫描QR码或在Google Play / Apple App Store中搜索IDP Study Abroad应用程式',
//     'thanksExisting': '欢迎回来！',
//     'thanksMessage': '请先到学生等候位置坐下，升学顾问即将与你会面。',
//     'done': '完成',
//     'thanks': '谢谢'
//   },
//   // China
//   CN_CHI: {
//     'appDescription': '下載我們的APP',
//     'appSubHeading': '為了幫助您走好每一步，請下載IDP Live app',
//     'courseInformation': '查看最新課程和大學訊息',
//     'recommendations': '收到個人化推薦',
//     'advice': '從世界各地的學生獲得建議',
//     'trackApplication': '追蹤你的申請',
//     'promoDescription': '掃描QR碼或在Google Play / Apple App Store中搜索IDP Study Abroad應用程式',
//     'thanksExisting': '歡迎回來！',
//     'thanksMessage': '請先到學生等候位置坐下，升學顧問即將與你會面。',
//     'done': '完成',
//     'thanks': '謝謝'
//   },
//   IR_FAS: {
//     'appDescription': 'Download our app',
//     'appSubHeading': 'برای کمک به شما در هر مرحله ، برنامه IDP Study Abroad را بارگیری کنید.',
//     'courseInformation': 'آخرین دوره ها و اطلاعات واحد را مشاهده کنید',
//     'recommendations': 'توصیه های شخصی را دریافت کنید',
//     'advice': 'از دانشجویان سراسر جهان مشاوره بگیرید',
//     'trackApplication': 'فرم درخواست خود را پیگیری کنید',
//     'promoDescription': 'کد QR را اسکن کنید یا برنامه IDP Study Abroad را در Google Play یا Apple App Store جستجو کنید',
//     'thanksExisting': 'از دیدن شما بسیار خوشحالیم!',
//     'thanksMessage': 'لطفاً در جای خود بنشینید و یک مشاور با شما خواهد بود.',
//     'done': 'انجام شده',
//     'thanks': 'متشکرم'
//   }
// }
// // sonar-ignore-end
